const readmoreStrings: { [lang: string]: string } = {
  de: "Mehr anzeigen",
  en: "Read more",
  it: "Scopri di più",
};
const readlessStrings: { [lang: string]: string } = {
  de: "Weniger anzeigen",
  en: "Read less",
  it: "Chiudi",
};

// readMore expands the card to let users read the full description
const readMore = (card: Element, cards: NodeListOf<Element>) => {
  const toggle = card.querySelector(".js-readmore");
  toggle?.addEventListener("click", e => {
    cards.forEach(c => {
      const cDescription = c.querySelector(".js-description");
      cDescription?.classList.toggle("line-clamp-3");
      const cToggle = c.querySelector(".js-readmore");
      if (cToggle === null) return;

      let lang = window.location.pathname.slice(1, 3).toLowerCase();
      if (lang !== "en" && lang !== "de" && lang !== "it") {
        lang = "en";
      }

      if (cToggle.innerHTML === readmoreStrings[lang]) {
        cToggle.innerHTML = readlessStrings[lang];
      } else {
        cToggle.innerHTML = readmoreStrings[lang];
      }
    });
  });
};

export default () => {
  const serviceCards = document.querySelectorAll(".js-servicecard");
  serviceCards.forEach(s => readMore(s, serviceCards));
  const dlcCards = document.querySelectorAll(".js-dlccard");
  dlcCards.forEach(s => readMore(s, dlcCards));
};
